require('../../modules/es6.object.get-prototype-of');
module.exports = require('../../modules/_core').Object.getPrototypeOf;



//////////////////
// WEBPACK FOOTER
// ./node_modules/.2.5.3@core-js/library/fn/object/get-prototype-of.js
// module id = 268
// module chunks = 0